import { cn } from '@/lib/utils';

const FILTERS = ['All', 'Today', 'This Week'] as const;

interface MockFilterBarProps {
  activeFilter?: (typeof FILTERS)[number];
  className?: string;
}

/**
 * MockFilterBar
 * フィルターピルバーのモックアップ
 * Web App Showcaseセクションで使用
 */
export function MockFilterBar({ activeFilter = 'All', className }: MockFilterBarProps) {
  return (
    <div className={cn('flex items-center gap-2 px-3 py-2.5 border-b border-border/50', className)}>
      {FILTERS.map((filter) => {
        const isActive = filter === activeFilter;
        return (
          <span
            key={filter}
            className={cn(
              'text-[10px] px-2.5 py-1 rounded-full border cursor-default',
              isActive
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-transparent text-muted-foreground border-border'
            )}
          >
            {filter}
          </span>
        );
      })}
    </div>
  );
}
